<template lang="pug">
  div
    div.header
      span.logout(@click="logout") ログアウト
    .l-content
      .l-container
        .c-container
          .c-container__image.u-text-center
            img.small-icon(
            src="@/assets/img/signup/suspended-checkmark.png"
            )
          .c-container__title.u-ptm.u-text-center
            span アカウントは利用停止中です
          .c-container__annotation
            span 現在、以下の理由に基づきアカウントの利用を停止しています。詳細を確認したい場合は
              a(href="mailto:support@gigbase.jp") こちら
              |よりお問い合わせください。
          .c-container__annotation
            div ・
              a.u-text-underline(href="https://plus.gigbase.jp/talent/talent-help/3469/#policy" target="_blank") キャンセルポリシー
              |に基づいたペナルティの執行
            div ・
              a.u-text-underline(href="https://gigbase.jp/terms" target="_blank") 利用規約
              |に違反する行為があった場合
            div ・その他当社が不適当と判断した場合
</template>

<script lang="babel">
import LogoutMixin from "@/mixins/LogoutMixin";

export default {
  name: 'AccountReviewPassed',
  mixins: [ LogoutMixin ],
}
</script>

<style lang="scss" scoped>
  .l-content {
    height: 100%;
  }
  .c-container {
    overflow: hidden;
    padding: {
      top: 100px;
    }
    &__title {
      font-size: 20px;
      line-height: 36px;
      text-align: center;
      margin-bottom: 40px;
    }
    &__annotation {
      font-size: 14px;
      line-height: 24px;
      &.u-mtm {
        margin-top: 36px;
      }
      .c-label {
        margin-left: 0px;
      }
      margin-bottom: 40px;
    }
  }
  .l-container.is-bottom {
    .c-button-float-lg {
      position: fixed;
      bottom: 24px;
      right: 16px;
      color: white;
      background-color: #F94848;
      box-shadow: 0px 5px 12px rgba(111, 0, 24, 0.2);
      .material-icons {
        vertical-align: initial;
      }
    }
    .c-button-floating-action-group {
      button:disabled {
        background: #E0E0E0;
      }
    }
  }
  .small-icon {
    width: 20%;
    margin-bottom: 10px;
  }
  .header {
    margin-top: 16px;
    margin-left: 16px;
  }
  .logout {
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.03em;
    color: #A6A5A5;
  }
</style>
